module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withTitle && _vm.person && _vm.person.id) ? [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("\n      Editing " + _vm._s(_vm.person.first_name) + " " + _vm._s(_vm.person.last_name) + "\n      "), _c('v-spacer')], 1)] : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('object-form', {
    attrs: {
      "errors": _vm.errors,
      "fields": _vm.fields
    },
    model: {
      value: (_vm.person),
      callback: function($$v) {
        _vm.person = $$v
      },
      expression: "person"
    }
  }, [_c('v-flex', {
    attrs: {
      "slot": "title",
      "xs12": ""
    },
    slot: "title"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.titles,
      "outline": _vm.hasErrors('title'),
      "error-messages": _vm.getErrors('title'),
      "label": "title"
    },
    model: {
      value: (_vm.person.title),
      callback: function($$v) {
        _vm.$set(_vm.person, "title", $$v)
      },
      expression: "person.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "slot": "email",
      "xs12": ""
    },
    slot: "email"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email address",
      "hint": "Please provide a valid email address",
      "outline": _vm.hasErrors('email'),
      "error-messages": _vm.getErrors('email'),
      "type": "email"
    },
    model: {
      value: (_vm.person.email),
      callback: function($$v) {
        _vm.$set(_vm.person, "email", $$v)
      },
      expression: "person.email"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "date_of_birth"
  }, [_c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "readonly": "",
      "append-icon": "event",
      "outline": _vm.hasErrors('date_of_birth'),
      "hint": _vm.birthdayHint,
      "error-messages": _vm.getErrors('date_of_birth'),
      "label": "date of birth"
    },
    on: {
      "click": function($event) {
        _vm.showBdayPicker = true
      },
      "click:append": function($event) {
        _vm.showBdayPicker = true
      }
    },
    model: {
      value: (_vm.person.date_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.person, "date_of_birth", $$v)
      },
      expression: "person.date_of_birth"
    }
  }), _vm._v(" "), _c('v-dialog', {
    staticClass: "text-xs-center",
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.showBdayPicker),
      callback: function($$v) {
        _vm.showBdayPicker = $$v
      },
      expression: "showBdayPicker"
    }
  }, [_c('birthday-picker', {
    on: {
      "close": function($event) {
        _vm.showBdayPicker = false
      }
    },
    model: {
      value: (_vm.person.date_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.person, "date_of_birth", $$v)
      },
      expression: "person.date_of_birth"
    }
  })], 1)], 1), _vm._v(" "), _c('phone-number-input', {
    attrs: {
      "slot": "cell_phone",
      "verbose": false
    },
    slot: "cell_phone",
    model: {
      value: (_vm.person.cell_phone),
      callback: function($$v) {
        _vm.$set(_vm.person, "cell_phone", $$v)
      },
      expression: "person.cell_phone"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "slot": "billing_address",
      "box": "",
      "persistent-hint": "",
      "hint": "We'll use this address on invoices",
      "label": "Billing address"
    },
    slot: "billing_address",
    model: {
      value: (_vm.person.billing_address),
      callback: function($$v) {
        _vm.$set(_vm.person, "billing_address", $$v)
      },
      expression: "person.billing_address"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "slot": "notes",
      "box": "",
      "persistent-hint": "",
      "hint": "Add any interesting information about the user here. For example, you might note who referred them, if they are related to another patient etc.",
      "label": "Bio"
    },
    slot: "notes",
    model: {
      value: (_vm.person.notes),
      callback: function($$v) {
        _vm.$set(_vm.person, "notes", $$v)
      },
      expression: "person.notes"
    }
  })], 2), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center mt-3"
  }, [(_vm.showAllFields === false) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showAllFields = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.showmore')) + "\n          ")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showAllFields = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('buttons.showless')) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), (_vm.withSearch) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('person-list', {
    attrs: {
      "with-edit": false
    }
  })], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310678ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/Person.vue
// module id = 1379
// module chunks = 9